// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"31":"b7914514d46461ce","496":"c0238dd47bc14dfb","619":"7923bb4a7524e5e6","829":"5188c29fc5362c3c"}[chunkId] + ".js";
};